module.exports = __webpack_public_path__ + "img/202111.c3c7aadc.jpg";